export interface CountryOption {
  name: string
  currency: string
  // IANA zone the restaurant's business hours are expressed in
  timezone: string
}

// India first — it's the default selection everywhere this list is used.
export const COUNTRIES: CountryOption[] = [
  { name: 'India', currency: 'INR', timezone: 'Asia/Kolkata' },
  { name: 'United Kingdom', currency: 'GBP', timezone: 'Europe/London' },
  { name: 'United States', currency: 'USD', timezone: 'America/New_York' },
  { name: 'United Arab Emirates', currency: 'AED', timezone: 'Asia/Dubai' },
  { name: 'Singapore', currency: 'SGD', timezone: 'Asia/Singapore' },
  { name: 'Australia', currency: 'AUD', timezone: 'Australia/Sydney' },
  { name: 'Canada', currency: 'CAD', timezone: 'America/Toronto' },
  { name: 'New Zealand', currency: 'NZD', timezone: 'Pacific/Auckland' },
  { name: 'Saudi Arabia', currency: 'SAR', timezone: 'Asia/Riyadh' },
  { name: 'Qatar', currency: 'QAR', timezone: 'Asia/Qatar' },
  { name: 'Kuwait', currency: 'KWD', timezone: 'Asia/Kuwait' },
  { name: 'Bahrain', currency: 'BHD', timezone: 'Asia/Bahrain' },
  { name: 'Oman', currency: 'OMR', timezone: 'Asia/Muscat' },
  { name: 'Malaysia', currency: 'MYR', timezone: 'Asia/Kuala_Lumpur' },
  { name: 'Indonesia', currency: 'IDR', timezone: 'Asia/Jakarta' },
  { name: 'Thailand', currency: 'THB', timezone: 'Asia/Bangkok' },
  { name: 'Philippines', currency: 'PHP', timezone: 'Asia/Manila' },
  { name: 'Sri Lanka', currency: 'LKR', timezone: 'Asia/Colombo' },
  { name: 'Bangladesh', currency: 'BDT', timezone: 'Asia/Dhaka' },
  { name: 'Nepal', currency: 'NPR', timezone: 'Asia/Kathmandu' },
  { name: 'South Africa', currency: 'ZAR', timezone: 'Africa/Johannesburg' },
  { name: 'Germany', currency: 'EUR', timezone: 'Europe/Berlin' },
  { name: 'France', currency: 'EUR', timezone: 'Europe/Paris' },
  { name: 'Ireland', currency: 'EUR', timezone: 'Europe/Dublin' },
  { name: 'Spain', currency: 'EUR', timezone: 'Europe/Madrid' },
  { name: 'Italy', currency: 'EUR', timezone: 'Europe/Rome' },
  { name: 'Netherlands', currency: 'EUR', timezone: 'Europe/Amsterdam' },
  { name: 'Switzerland', currency: 'CHF', timezone: 'Europe/Zurich' },
  { name: 'Japan', currency: 'JPY', timezone: 'Asia/Tokyo' },
  { name: 'Hong Kong', currency: 'HKD', timezone: 'Asia/Hong_Kong' }
]

export const COUNTRY_NAMES = COUNTRIES.map(c => c.name)

export const DEFAULT_COUNTRY = 'India'

const CURRENCY_LOCALES: Record<string, string> = {
  INR: 'en-IN',
  GBP: 'en-GB',
  USD: 'en-US',
  AED: 'en-AE',
  SGD: 'en-SG',
  AUD: 'en-AU',
  CAD: 'en-CA',
  NZD: 'en-NZ',
  SAR: 'en-SA',
  QAR: 'en-QA',
  KWD: 'en-KW',
  BHD: 'en-BH',
  OMR: 'en-OM',
  MYR: 'en-MY',
  IDR: 'id-ID',
  THB: 'th-TH',
  PHP: 'en-PH',
  LKR: 'en-LK',
  BDT: 'en-BD',
  NPR: 'en-NP',
  ZAR: 'en-ZA',
  EUR: 'en-IE',
  CHF: 'de-CH',
  JPY: 'ja-JP',
  HKD: 'en-HK'
}

export function getTimezoneForCountry(country: string | undefined | null): string {
  return COUNTRIES.find(c => c.name === country)?.timezone || 'Asia/Kolkata'
}

export function getCurrencyForCountry(country: string | undefined | null): string {
  return COUNTRIES.find(c => c.name === country)?.currency || 'INR'
}

export function getCurrencyLocale(currencyCode: string | undefined | null): string {
  return (currencyCode && CURRENCY_LOCALES[currencyCode]) || 'en-US'
}

export function getCurrencySymbol(currencyCode: string | undefined | null): string {
  const code = currencyCode || 'INR'
  try {
    const parts = new Intl.NumberFormat(getCurrencyLocale(code), {
      style: 'currency',
      currency: code,
      currencyDisplay: 'narrowSymbol'
    }).formatToParts(0)
    return parts.find(p => p.type === 'currency')?.value || code
  } catch {
    return code
  }
}
